import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import "../assets/css/Campaigns.css";
import "../assets/css/Vox.css";
import config from "../config";
import { useUser } from "../context/UserContext";
import { READY_STATUS } from "../utils/common/constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../components/sidebar";
import { handleContactCall } from "../utils/common/helpers";

function EventDetailPage() {
  const { number } = useParams();
  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  const [updateContactData, setUpdateContactData] = useState({});
  const [updateContactformErrors, setupdateContactformErrors] = useState({});
  const [notes, setNotes] = useState([]);
  const [showModal, setShowModal] = useState(true);
  const [dispositionData, setDispositionData] = useState([]);
  const [configData, setConfigData] = useState({
    vertical_types: [],
    interaction_subcategories: [],
    interaction_categories: [],
    interaction_types: [],
    caller_types: []
  });
  const agent_id = localStorage.getItem('agent_id');


  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const paramData = JSON.parse(decodeURIComponent(query.get("data")));

  const ticket_required = [
    {label: "No", value: 0},
    {label: "Yes", value: 1},
  ]

  // useEffect(() => {
  //   const eventSource = fetchEvents();

  //   return () => {
  //     if (eventSource) {
  //       eventSource.close();
  //     }
  //   };

  // }, []);

   async function fetchDisposition() {
    const token = localStorage.getItem("token");

    try {
      const res = await fetch(
        `${config.apiBaseUrl}/api/v1/reports/${number}/call-disposition?limit=5`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const disResult = await res.json();

      if (disResult?.success) {
        setNotes(disResult.data);
        setDispositionData(disResult.data);

        const latestNote = disResult.data[0];

        setUpdateContactData(prevData => ({
          ...prevData,
          registration_number: latestNote?.registration_number,
          id: latestNote?.order_ID,
        }));
      }
    } catch (err) {
      console.error("Error fetching disposition:", err);
    }
  }


  async function getContactCall(){

    const response = await handleContactCall(number, undefined, undefined, undefined, 0);
      // const response = {
      //   success: true, data: {contact: {name: "Test Call"}}
      // };

    if(response && response.success){
        const data = response.data;
        setUpdateContactData({
          name: data?.contact?.name || "",
          last_name: data?.contact?.last_name || "",
          contact_primary:number,
          company: data?.contact?.company,
          street: data?.contact?.street || "",
          city: data?.contact?.city || "",
          state: data?.contact?.state || "",
          country: data?.contact?.country || "",
          title: "",
          contact_id: data?.contact?.id,
          // registration_number: data?.contact?.registration_number,
          name: data?.contact?.name,
          // id: data?.contact?.id,
          vertical_type: data?.contact?.vertical_type,
          order_id: data?.contact?.order_id,
          caller_type: data?.contact?.caller_type,
          interaction_type: data?.contact?.interaction_type,
          interaction_category: data?.contact?.interaction_category,
          interaction_sub_category: data?.contact?.interaction_sub_category,
          note: data?.contact?.note,
          ticket_required: data?.contact?.ticket_required,
        });
    }

  }  

  useEffect(() => {
     //getContactInfoByNumber(number);
     getContactCall();
    // setUpdateContactData({
    //   first_name: paramData?.data?.contact?.first_name || "",
    //   last_name: paramData?.data?.contact?.last_name || "",
    //   contact_primary: paramData?.data?.callerNumber,
    //   name: paramData?.data?.contact?.name || "",
    //   company: paramData?.data?.contact?.company || "",
    //   street: paramData?.data?.contact?.street || "",
    //   city: paramData?.data?.contact?.city || "",
    //   state: paramData?.data?.contact?.state || "",
    //   country: paramData?.data?.contact?.country || "",
    //   remarks: "",
    //   remarksTitle: "",
    //   contact_id: paramData?.data?.contact?.id,
    // });
    // setNotes(paramData?.data?.notes);
    fetchDisposition();
  }, [number]);

  const fetchNotes = async (contactId) => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${config.apiBaseUrl}/api/v1/reports/${contactId}/notes`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const result = await response.json();

      if (result.success) {
        setNotes(result.data);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    }
  };

  const getContactInfoByNumber = async (number) => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await fetch(`${config.apiBaseUrl}/api/v1/contacts/${number}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const result = await response.json();

      if (result.success) {
        const data = result.data;
        // fetchNotes(data?.id);
        setUpdateContactData({
          first_name: data?.first_name || "",
          last_name: data?.last_name || "",
          name: data?.name || "",
          contact_primary: data?.contact_primary,
          company: data?.company || "",
          street: data?.street || "",
          city: data?.city || "",
          state: data?.state || "",
          country: data?.country || "",
          remarks: "",
          remarksTitle: "",
          contact_id: data?.id,
        });
      }
    } catch (error) {
      console.error("Error fetching scripts:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEvents = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    const token = localStorage.getItem("token");
    const eventSource = new EventSource(`${config.inboundCallApiBaseUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    eventSource.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch (error) {
        console.error('Invalid response received:', error);
        return;
      }
      if (data) {

        if (data.data?.agentId !== agent_id) {
          return;
        }

        const userReadyStatus = (parseInt(localStorage.getItem("isReadyForCall"), 10) ?? 0);

        if (userReadyStatus !== READY_STATUS.ACTIVE) return;

        if (data.data?.callerNumber) {
          getContactInfoByNumber(data.data?.callerNumber);
        }
        setUpdateContactData({
          first_name: data.data.contact?.first_name || "",
          last_name: data.data.contact?.last_name || "",
          contact_primary: data.data.callerNumber,
          company: data.data.contact?.company || "",
          street: data.data.contact?.street || "",
          city: data.data.contact?.city || "",
          state: data.data.contact?.state || "",
          country: data.data.contact?.country || "",
          remarks: "",
          remarksTitle: "",
          contact_id: data.data.contact?.id,
        });

        setNotes(data.data?.notes);
        setShowModal(true);
        setLoading(false);

      } else {
        // setShowModal(false);
      }
    };

    eventSource.onerror = (error) => {
      console.error("Error receiving event data:", error);
      eventSource.close();
      setLoading(false);
      setShowModal(false);
    };

    return eventSource;

  };

  function getPlainText(remarks) {
    try {
      const parsedRemarks = JSON.parse(remarks);

      if (parsedRemarks.blocks && Array.isArray(parsedRemarks.blocks)) {
        return parsedRemarks.blocks.map((block) => block.text).join(" ");
      }
    } catch (e) { }

    return remarks;
  }

  const changeContactValue = (e) => {
    const { name, value } = e.target;
    setUpdateContactData({ ...updateContactData, [name]: value });
    setupdateContactformErrors({ ...updateContactformErrors, [name]: "" });
  };

  const validateUpdateContactFields = () => {
    const errors = {};
    // if (!updateContactData?.first_name) {
    //   errors.first_name = "First name is required";
    // }
    // if (!updateContactData?.last_name) {
    //   errors.last_name = "Last name is required";
    // }
    if (!updateContactData?.contact_primary) {
      errors.contact_primary = "Contact number is required";
    } if (!updateContactData?.vertical_type) {
      errors.vertical_type = "Vertical type is required";
    } if (!updateContactData?.caller_type) {
      errors.caller_type = "Caller type is required";
    } if (!updateContactData?.interaction_type) {
      errors.interaction_type = "Interaction type is required";
    } if (!updateContactData?.interaction_category) {
      errors.interaction_category = "Interaction Category is required";
    }if (!updateContactData?.interaction_sub_category) {
      errors.interaction_sub_category = "Interaction Sub Category is required";
    }if (!updateContactData?.ticket_required) {
      errors.ticket_required = "Ticket is required";
    }
    // if (!updateContactData?.remarks) {
    //   errors.remarks = "Remarks is required";
    // }
    // if (!updateContactData?.remarksTitle) {
    //   errors.remarksTitle = "Remarks title is required";
    // }
    // if (!updateContactData?.company) {
    //   errors.company = "Company is required";
    // }
    // if (!updateContactData?.state) {
    //   errors.state = "State is required";
    // }
    // if (!updateContactData?.street) {
    //   errors.street = "Street is required";
    // }
    // if (!updateContactData?.city) {
    //   errors.city = "City is required";
    // }
    // if (!updateContactData?.country) {
    //   errors.country = "Country is required";
    // }
    setupdateContactformErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleUpdateContact = async (e, status = false) => {
    if (loading) {
      return;
    }

    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (!validateUpdateContactFields()) {
      return;
    }

    const contactNumberList = [
      {
        value: updateContactData.contact_primary,
        type: "1",
      },
    ];

    const dataToSend = {
      // first_name: updateContactData.first_name,
      // last_name: updateContactData.last_name,
      // contact_number: contactNumberList,
      // company: updateContactData.company,
      // street: updateContactData.street,
      // city: updateContactData.city,
      // state: updateContactData.state,
      // country: updateContactData.country,
      // remarks: updateContactData.remarks,
      // title: updateContactData.remarksTitle,
      // created_by: user.id

      contact_number: contactNumberList,
      registration_number: updateContactData.registration_number,
      name: updateContactData.name,
      id: updateContactData.id,
      vertical_type: updateContactData.vertical_type,
      order_id: updateContactData.order_id,
      caller_type: updateContactData.caller_type,
      interaction_type: updateContactData.interaction_type,
      interaction_category:updateContactData.interaction_category,
      interaction_sub_category: updateContactData.interaction_sub_category,
      note: updateContactData.note,
      ticket_required: updateContactData.ticket_required,
      parse_id: updateContactData.parse_id,
      city_id: updateContactData.city_id,
      created_by: user.id,
      
    };

    // Filter out any keys with value undefined, null, or empty string
    const cleanedData = Object.entries(dataToSend).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    const token = localStorage.getItem("token");

    setLoading(true);

    try {
      const response = await fetch(
        `${config.apiBaseUrl}/api/v1/contacts/${updateContactData.contact_primary}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(cleanedData),
        }
      );

      const data = await response.json();

      if (data.success) {
        toast.success(data.message || "Contact updated successfully");
        setShowModal(false);
        // setUpdateContactData({});
        setupdateContactformErrors({});
      } else {
        toast.error(data.message || "Failed to updated contact");
      }
    } catch (error) {
      console.error("Error updating contact:", error);
      toast.error("Error updating contact");
    } finally {
      setLoading(false);
      setTimeout(() => window.close(), 1500);
    }
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await fetch(
          `${config.apiBaseUrl}/api/v1/reports/call-disposition/config`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await res.json();
        if (result.success) {
          setConfigData(result.data);
        }
      } catch (err) {
        console.error("Config fetch error:", err);
      }
    };

    fetchConfig();
  }, []);
  const OPTION_MAP = {
    vertical_type: configData.vertical_types,
    ticket_required: ticket_required,
    interaction_category: configData.interaction_categories,
    caller_type: configData.caller_types,
    interaction_type: configData.interaction_types,
    interaction_sub_category: configData.interaction_subcategories
  };
  
  const getLabel = (field, value) => {
    if (value === null || value === undefined || value === "") return "-";
    const source = OPTION_MAP[field];
    if (!Array.isArray(source)) return String(value);
    const found = source.find((opt) => Number(opt.id) === Number(value));
    return found ? found.value : String(value);
  };

  return (
    <>
    <Sidebar />
      {showModal && (
        <div className="mt-5"
        //   className="modal-overlay"
        //   style={{
        //     zIndex: 999999,
        //     position: "fixed",
        //     top: 0,
        //     left: 0,
        //     width: "100%",
        //     height: "100%",
        //     backgroundColor: "rgba(0, 0, 0, 0.5)",
        //     overflowY: "auto",
        //   }}
        >
          <ToastContainer style={{ marginTop: "80px" }} />
          <div className="modal-xl modal-dialog modal-dialog-centered custom-modal-width">
            <div
              className="modal-content"
              style={{ backgroundColor: "#fcfcfc" }}
            >
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                }}
              >
                <h5 className="modal-title" style={{ margin: 0 }}>
                  Contact Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "1.5rem",
                    lineHeight: "1",
                  }}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="lyt_box mt-4">
                  <div className="row g-4">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                      <div className="block-widget">
                        <h6>Form</h6>
                        <form onSubmit={(e) => handleUpdateContact(e, false)}>
                          <div className="form_group">
                            <label className="form-label">Contact Number</label>
                            <input
                              type="number"
                              className="form-control"
                              name="contact_primary"
                              value={updateContactData.contact_primary || ""}
                              onChange={changeContactValue}
                            />
                            {updateContactformErrors.contact_primary && (
                              <div className="error">
                                <span className="text-danger">
                                  {updateContactformErrors.contact_primary}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="form_group">
                            <label className="form-label">Registration Number</label>
                            <input
                              type="number"
                              className="form-control"
                              name="registration_number"
                              value={updateContactData.registration_number || ""}
                              onChange={changeContactValue}
                            />
                          </div>
                          <div className="form_group">
                            <label className="form-label">Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              value={updateContactData.name || ""}
                              onChange={changeContactValue}
                            />
                          </div>
                          <div className="form_group">
                            <label className="form-label">ID</label>
                            <input
                              type="number"
                              className="form-control"
                              name="id"
                              value={updateContactData.id || ""}
                              onChange={changeContactValue}
                            />
                          </div>
                          <div className="form_group">
                          <label className="form-label">Parse ID</label>
                          <input
                            type="text"
                            className="form-control"
                            name="parse_id"
                            value={updateContactData.parse_id || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">City ID</label>
                          <input
                            type="text"
                            className="form-control"
                            name="city_id"
                            value={updateContactData.city_id || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                          <div className="form_group">
                            <label className="form-label">Vertical Type</label>
                            <select id="source-type" name="vertical_type"  value={updateContactData.vertical_type || ""}
                              onChange={(e) => {
                                const v = e.target.value;
                                setUpdateContactData((prev) => ({
                                  ...prev,
                                  vertical_type: v,
                                  caller_type: "",
                                  interaction_category: "",
                                  interaction_sub_category: "",
                                  interaction_type: ""
                                }));
                              }}>
                              <option value="" disabled selected>Select Vertical Type</option>
                              {configData.vertical_types.map((item) => (
                                <option key={item.id} value={item.id}>{item.value}</option>
                              ))}
                            </select>
                            {updateContactformErrors.vertical_type && (
                              <div className="error">
                                <span className="text-danger">
                                  {updateContactformErrors.vertical_type}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="form_group">
                            <label className="form-label">Consignment/Ride/Order ID</label>
                            <input
                              type="text"
                              className="form-control"
                              name="order_id"
                              value={updateContactData.order_id || ""}
                              onChange={changeContactValue}
                            />
                          </div>
                          <div className="form_group">
                            <label className="form-label">Caller Type</label>
                            <select id="caller-type"
                              name="caller_type"  
                              value={updateContactData.caller_type || ""}
                              onChange={changeContactValue}>
                              <option value="" disabled selected>Select Caller Type</option>
                              {configData.caller_types.filter((item) => String(item.vertical_type_id) === String(updateContactData.vertical_type))
                                .map((type, index) => (
                                  <option key={type.id} value={type.id}>{type.value}</option>
                                ))}
                            </select>
                            {updateContactformErrors.caller_type && (
                              <div className="error">
                                <span className="text-danger">
                                  {updateContactformErrors.caller_type}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="form_group">
                            <label className="form-label">Interaction Sub Category</label>
                            <select id="source-type" name="interaction_sub_category"
                              value={updateContactData.interaction_sub_category || ""}
                              onChange={(e) => {
                                const subCatId = e.target.value;
                                const category = configData.interaction_categories.find(
                                  (item) => String(item.sub_cat_id) === String(subCatId));
                                const type = configData.interaction_types.find(
                                  (item) => String(item.sub_cat_id) === String(subCatId));
                                setUpdateContactData((prev) => ({
                                  ...prev,
                                  interaction_sub_category: subCatId,
                                  interaction_category: category?.id || "",
                                  interaction_type: type?.id || ""
                                }));
                              }}>
                              <option value="" disabled> Select Interaction Sub Category </option>
                              {configData.interaction_subcategories.filter((item) =>
                                String(item.vertical_type_id) === String(updateContactData.vertical_type)
                              ).map((item) => (
                                <option key={item.id} value={item.id}> {item.value} </option>
                              ))}
                            </select>
                            {updateContactformErrors.interaction_sub_category && (
                              <div className="error">
                                <span className="text-danger">
                                  {updateContactformErrors.interaction_sub_category}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="form_group">
                            <label className="form-label">Interaction Category</label>
                            <select id="source-type" name="interaction_category"
                              value={updateContactData.interaction_category || ""}
                              onChange={changeContactValue}>
                              <option value="" disabled>Select Interaction Sub Category first</option>
                              {configData.interaction_categories.filter((item) =>
                                String(item.sub_cat_id) === String(updateContactData.interaction_sub_category)
                              ).map((item) => (
                                <option key={item.id} value={item.id}> {item.value} </option>
                              ))}
                            </select>
                            {updateContactformErrors.interaction_category && (
                              <div className="error">
                                <span className="text-danger">
                                  {updateContactformErrors.interaction_category}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="form_group">
                            <label className="form-label">Interaction Type</label>
                            <select name="interaction_type" value={updateContactData.interaction_type || ""} onChange={changeContactValue}>
                              <option value="" disabled>Select Interaction Sub Category first</option>
                              {configData.interaction_types.filter((item) =>
                                String(item.sub_cat_id) === String(updateContactData.interaction_sub_category)
                              ).map((item) => (
                                <option key={item.id} value={item.id}> {item.value} </option>
                              ))}
                            </select>
                            {updateContactformErrors.interaction_type && (
                              <div className="error">
                                <span className="text-danger">
                                  {updateContactformErrors.interaction_type}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="form_group">
                            <label className="form-label">Note</label>
                            <textarea className="form-control" name="note" value={updateContactData.note || ""}
                              onChange={changeContactValue} rows={4} style={{ height: "100px" }}/>
                          </div>
                          <div className="form_group">
                            <label className="form-label">Ticket required</label>
                            <select id="source-type" name="ticket_required" value={updateContactData.ticket_required || ""} onChange={changeContactValue}>
                              <option value="" disabled selected>Select Ticket required</option>
                              {ticket_required.map((item, index)=>(
                                <option key={index} value={item.value}>{item.label}</option>
                              ))}
                            </select>
                             {updateContactformErrors.ticket_required && (
                              <div className="error">
                                <span className="text-danger">
                                  {updateContactformErrors.ticket_required}
                                </span>
                              </div>
                            )}
                          </div>

                          <button className="btn btn-primary" type="submit" disabled={loading}> Submit </button>
                        </form>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 d-flex flex-column">
                      <div className="block-widget">
                        <div style={{ overflowY: "auto", width: "100%" }}>
                          <table
                            className="table table-striped"
                            style={{ width: "100%", tableLayout: "fixed" }}
                          >
                            <thead>
                              <tr>
                                <th style={{ width: "33%" }}>Agent name</th>
                                <th style={{ width: "33%" }}>Remark</th>
                                <th style={{ width: "33%" }}>Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(notes) && notes.length > 0 ? (
                                notes.map((note, index) => (
                                  <tr key={note.id}>
                                    <td
                                      style={{
                                        width: "33%",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {note["UserDetail.Agents.agent_name"] ||
                                        ""}
                                    </td>
                                    <td
                                      style={{
                                        width: "33%",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {getPlainText(note.note)}
                                    </td>
                                    <td
                                      style={{
                                        width: "33%",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {note.created_at}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="block-widget mt-3" style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                      <h5 className="mb-2">Last Call Dispositions</h5>
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Vertical Type</th>
                            <th>Caller Type</th>
                            <th>Interaction Category</th>
                            <th>Interaction Sub Category</th>
                          </tr>
                        </thead>

                        <tbody>
                          {dispositionData.length > 0 ? (
                            dispositionData.map((item) => (
                              <tr key={item.id}>
                                <td>{item.created_at.split(" ")[0]}</td>
                                <td>{getLabel("vertical_type", item.vertical_type)}</td>
                                <td>{getLabel("caller_type", item.caller_type, item.vertical_type)}</td>
                                <td>{getLabel("interaction_category", item.interaction_category, item.vertical_type)}</td>
                                <td>{getLabel("interaction_sub_category", item.interaction_sub_category, item.interaction_category)}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No recent dispositions
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EventDetailPage;
